/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { HarmonizerMessageRoles } from '@medflex/shared-types';
import { format } from 'date-fns';
import useClassNames from '@medflex/hooks/useClassNames';
import Button, { KINDS as ButtonKinds } from '../../Button';

export const PLACEMENT = {
  START: 'start',
  END: 'end',
};

export const KINDS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

const InquiryCallDetailsMessage = ({
  startElement,
  message,
  onAudioSkipSeconds,
  placement = PLACEMENT.START,
  kind = KINDS.PRIMARY,
}) => {
  const { content, timeInCallSeconds } = message;
  const csPosition = useClassNames(
    () => [
      'text-left rounded-md p-2 @md:w-1/2 border-1 border-slate-200',
      {
        'place-self-end': placement === PLACEMENT.END,
        'bg-slate-100': kind === KINDS.SECONDARY,
      },
    ],
    [placement, kind],
  );

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      key={`${content}${timeInCallSeconds}`}
      className={csPosition}
      onClick={() => onAudioSkipSeconds(timeInCallSeconds)}
    >
      <div className="flex gap-x-2">
        {startElement}
        <div className="flex-grow">{content}</div>
        <Button
          className="place-self-end"
          kind={ButtonKinds.LINK}
          onClick={() => onAudioSkipSeconds(timeInCallSeconds)}
        >
          {format(timeInCallSeconds * 1000, 'mm:ss')}
        </Button>
      </div>
    </div>
  );
};

InquiryCallDetailsMessage.propTypes = {
  placement: PropTypes.oneOf(Object.values(PLACEMENT)),
  kind: PropTypes.oneOf(Object.values(KINDS)),
  message: PropTypes.shape({
    role: PropTypes.oneOf(Object.values(HarmonizerMessageRoles)),
    content: PropTypes.string,
    createdAt: PropTypes.string,
    timeInCallSeconds: PropTypes.number,
  }).isRequired,
  onAudioSkipSeconds: PropTypes.func.isRequired,
  startElement: PropTypes.node,
};

export default InquiryCallDetailsMessage;
